import { $t } from '@/utils/languageAuto';
import { __assign, __awaiter, __decorate, __extends, __generator } from "tslib";
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { loading } from '@/decorators';

var AddEditModal = function (_super) {
  __extends(AddEditModal, _super);

  function AddEditModal() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.dataList = [];
    _this.visible = false;
    _this.loading = false;
    _this.total = 0;
    _this.searchData = _this.initSearchData();
    _this.columns = [{
      title: _this.t('操作人'),
      dataIndex: 'create_user',
      filterEmpty: true
    }, {
      title: _this.t('操作类型'),
      dataIndex: 'oper_type_text',
      filterEmpty: true
    }, {
      title: _this.t('备注'),
      dataIndex: 'oper_content',
      width: 280,
      filterEmpty: true
    }, {
      title: _this.t('时间'),
      dataIndex: 'create_time',
      filterEmpty: true
    }];
    return _this;
  }

  AddEditModal.prototype.initSearchData = function () {
    return {
      consumable_code: '',
      page_index: 1,
      page_size: 20
    };
  };

  AddEditModal.prototype.onVisibleChange = function (val) {
    if (val) {
      this.searchData = this.initSearchData();
      this.queryLogList();
    } else {
      this.dataList = [];
    }
  };

  AddEditModal.prototype.handlePageChange = function (val) {
    this.searchData.page_index = val;
    this.queryLogList();
  };

  AddEditModal.prototype.queryLogList = function () {
    return __awaiter(this, void 0, void 0, function () {
      var params, data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            params = __assign(__assign({}, this.searchData), {
              consumable_code: this.consumable_code
            });
            return [4, this.$api.wrapper.queryConsumableMaterialLogs(params)];

          case 1:
            data = _a.sent().data;
            this.dataList = data.list;
            this.total = +data.total || 0;
            return [2];
        }
      });
    });
  };

  __decorate([Prop({
    type: String,
    "default": ''
  })], AddEditModal.prototype, "consumable_code", void 0);

  __decorate([Watch('visible', {
    immediate: true
  })], AddEditModal.prototype, "onVisibleChange", null);

  __decorate([loading('loading')], AddEditModal.prototype, "queryLogList", null);

  AddEditModal = __decorate([Component], AddEditModal);
  return AddEditModal;
}(Vue);

export default AddEditModal;